<template>
	<div class="shop-msg-page">
		<!-- 页面头部（导航栏 + 面包屑） -->
		<newsPageHeader :gtype="0" />
		
		<!-- ====== 产品详情区域 ====== -->
		<div class="product-detail-card animate__animated animate__fadeInUp">
			<!-- 左侧：轮播图 + 缩略图 -->
			<div class="product-left-col">
				<div class="carousel-main-wrap">
					<el-carousel
						ref="carouselRef"
						:autoplay="true"
						:interval="3000"
						arrow="always"
						:initial-index="0"
						indicator-position="none"
						height="394px"
						trigger="click"
						@change="onCarouselChange">
						<template v-for="(item,index) in bannerList">
						<!-- 第1项：视频 -->
						<el-carousel-item v-if="item.id==-1">
							<div class="carousel-video-wrap">
								<video
									class="carousel-video"
									:src="item.url"
									poster=""
									controls
									playsinline
									preload="metadata">
								</video>
								<div class="video-poster-overlay" @click="playVideo">
									<el-image class="play-big-icon" :src="require('@/static/CodeBuddyAssets/30831_3003/11.svg')"></el-image>
								</div>
							</div>
						</el-carousel-item>
						<!-- 第2-7项：图片 -->
						<el-carousel-item v-else>
							<el-image
								class="carousel-image"
								:src="item.url"
								:preview-src-list="[item.url]"
								fit="cover">
							</el-image>
						</el-carousel-item>
						</template>
					</el-carousel>
				</div>
				<!-- 缩略图区域 -->
				<div class="thumbnail-strip-wrap">
					<div class="thumbnail-strip" ref="thumbStrip">
						<div
							v-for="(item, idx) in bannerList"
							:key="idx"
							class="thumb-item"
							:class="{ 'thumb-active': currentSlide === idx }"
							@click="goToSlide(idx)">
							<div class="thumb-video-mark" v-if="item.id === -1">
								<el-image :src="require('@/static/CodeBuddyAssets/30831_3003/11.svg')"></el-image>
							</div>
							<el-image
								class="thumb-img"
								:src="item.url"
								fit="cover">
							</el-image>
						</div>
					</div>
				</div>
			</div>

			<!-- 右侧：商品信息 -->
			<div class="product-right-col">
				
				<div class="product-title-w f-bct">
					<h2 class="product-title">{{goods.name}}</h2>
					<div class="action-btns">
						<div class="action-btn" @click="copy_txt(goodsAll.itemUrl)" v-if="channelType!=1">
							<el-image :src="require('@/static/CodeBuddyAssets/30831_3003/18.svg')"></el-image>
							<span>原链接</span>
						</div>
						<div class="action-divider" v-if="channelType!=1"></div>
						<div class="action-btn" @click="zhaoLike">
							<el-image :src="require('@/static/CodeBuddyAssets/30831_3003/19.svg')"></el-image>
							<span>找相似</span>
						</div>
					</div>
				</div>
				
				<div class="price-row">
					<span class="price-value">
						<span class="price-symbol">￥</span>
						<span class="price-amount">{{goods.retailPrice}}</span>
					</span>
					<span class="price-sales">{{goods.virtualSales||'969'}}人付款</span>
				</div>
				
				<div class="store-row-w f-bct" v-if="channelType!=1">
					<div class="store-row">
						<el-image class="store-avatar" :src="require('@/static/CodeBuddyAssets/30831_3003/40.svg')"></el-image>
						<div class="store-info">
							<span class="store-name">{{goodsAll.shopName}}</span>
							<div class="store-stars">
								<el-image :src="require('@/static/CodeBuddyAssets/30831_3003/24.svg')"></el-image>
								<el-image :src="require('@/static/CodeBuddyAssets/30831_3003/25.svg')"></el-image>
								<el-image :src="require('@/static/CodeBuddyAssets/30831_3003/26.svg')"></el-image>
								<el-image :src="require('@/static/CodeBuddyAssets/30831_3003/27.svg')"></el-image>
								<el-image :src="require('@/static/CodeBuddyAssets/30831_3003/28.svg')"></el-image>
							</div>
						</div>
						<el-image class="store-arrow" :src="require('@/static/CodeBuddyAssets/30831_3003/29.svg')"></el-image>
					</div>
					<!-- <div class="coupon-row">
						<div class="coupon-btn">领券满20减5</div>
					</div> -->
				</div>
				
				<!-- 规格 -->
				<div>
					<div class="specs-row" v-for="(item, index) in goodsSpecificationVoList">
						<span class="specs-label">{{item.name}}</span>
						<div class="spec-options">
							<div :class="['spec-option', { 'spec-active': selGoodsArr[index]==itm.value }]" @click="selGuige(index,itm)" v-for="(itm, idx) in item.valueList">{{itm.value}}</div>
						</div>
					</div>
				</div>

				<div class="quantity-row">
					<span class="quantity-label">数量</span>
					<div class="quantity-control">
						<div class="qty-btn qty-minus" @click="decreaseQty">
							<el-image :src="require('@/static/CodeBuddyAssets/30831_3003/21.svg')"></el-image>
						</div>
						<el-input class="qty-input" v-model="quantity" :min="1" size="small"></el-input>
						<div class="qty-btn qty-plus" @click="increaseQty">
							<el-image :src="require('@/static/CodeBuddyAssets/30831_3003/20.svg')"></el-image>
						</div>
					</div>
				</div>

				<div class="purchase-notes">
					<div class="note-line">
						<span class="note-star">*</span>
						<span class="note-text">不含国际运费</span>
					</div>
					<div class="note-line" style="margin-top: 0.1rem;">
						<span class="note-star">*</span>
						<span class="note-text">购买须知：{{goods.purchaseNotes||'暂无'}}</span>
					</div>
				</div>

				<div class="cart-btns">
					<div class="cart-btn cart-add" @click="addToCart">加入购物车</div>
					<div class="cart-btn cart-buy" @click="buyNow">立即购买</div>
				</div>
			</div>
		</div>

		<!-- ====== 推荐商品 + 商品详情 ====== -->
		<div class="product-bottom-section animate__animated animate__fadeInUp">
			<!-- 左侧：推荐商品 -->
			<div class="recommend-sidebar">
				<h3 class="recommend-title">商品推荐</h3>
				<div class="recommend-divider"></div>
				<template v-for="(item,index) in hotGoodsList">
				<div class="recommend-divider" v-if="index"></div>
				<div class="recommend-item" @click="gogmsg(item)">
					<el-image class="recommend-img" :src="item.picUrl" :preview-src-list="[item.picUrl]" fit="cover"></el-image>
					<div class="name line2">
						<span class="recommend-tag tag-blue">自营</span>{{ item.name }}
					</div>
					<div class="recommend-price">
						<span class="r-price-symbol">￥</span>
						<span class="r-price-value">{{ item.retailPrice }}</span>
					</div>
				</div>
				</template>
			</div>
			<!-- 右侧：商品详情 -->
			<div class="detail-main">
				<h3 class="detail-title">商品详情</h3>
				<div class="detail-image-wrap" v-html="goods.detail">
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
import {
	goodsdetail,
	homeindex,
	cartadd
} from "/src/api/api.js"
import newsPageHeader from '@/components/newsPageHeader.vue'
export default {
	name: 'ShopMsg',
	components: {
		newsPageHeader
	},
	data() {
		return {
			id:0,
			itemUrl:'',
			channelType:1,
			// 获取信息
			goodsAll:'',
			goods:'',
			bannerList:[],
			// 规格
			selGoods:'',
			selGoodsArr:'',
			goodsProductList:'',
			goodsSpecificationVoList:'',
			// 数量
			quantity: 1,
			// 轮播
			currentSlide: 0,
			// 推荐
			hotGoodsList:[],
		}
	},
	watch: {
		// 或直接监听 $route.query.id
		'$route.query.id'(newVal, oldVal) {
			if (newVal !== oldVal) {
				console.log('id 变化:', oldVal, '->', newVal);
				this.id = this.$route.query.id*1
				this.channelType = this.$route.query.channelType*1
				this.goodsdetailGet()
				this.homeindexGet()
			}
		}
	},
	mounted() {
		if(this.$route.query.id){
			this.id = this.$route.query.id*1
		}
		if(this.$route.query.itemUrl){
			this.itemUrl = this.$route.query.itemUrl
		}
		if(this.$route.query.channelType){
			this.channelType = this.$route.query.channelType*1
		}
		this.goodsdetailGet()
		this.homeindexGet()
	},
	methods: {
		// 加入购物车
		async addToCart() {
			if(!this.selGoods){
				this.Tsip('请选择规格')
				return
			}
			const res = await cartadd({
				channelType:this.channelType,
				goodsId:this.id,
				number:this.quantity,
				productId:this.selGoods.id,
			})
			if(res.code==200){
				this.Tips(res.msg)
			}else{this.Tips(res.msg,'error')}
		},
		// 立即购买
		async buyNow() {
			if(!this.selGoods){
				this.Tsip('请选择规格')
				return
			}
			const res = await cartadd({
				channelType:this.channelType,
				goodsId:this.id,
				number:this.quantity,
				productId:this.selGoods.id,
			})
			if(res.code==200){
				this.link('/shopOrder',{id:res.data.id})
			}else{this.Tips(res.msg,'error')}
		},
		// 招相似
		zhaoLike(){
			this.link('/shopIndex',{channelType:this.goods.channelType*1,linkPlink:this.goods.picUrl})
		},
		// 跳商品
		gogmsg(item){
			this.link('/shopMsg',{id:item.id,channelType:1})
		},
		// 获取代购首页信息
		async homeindexGet(){
			var res;
			res = await homeindex({});
			if(res.code==200){
				this.hotGoodsList = res.data.hotGoodsList
			}else{this.Tips(res.msg,'error')}
		},
		// 商品详情
		async goodsdetailGet(){
			var data = {}
			if(this.id){
				data = {itemId:this.id,channelType:this.channelType}
			}
			if(this.itemUrl){
				data = {itemUrl:this.itemUrl,channelType:this.channelType}
			}
			const res = await goodsdetail(data)
			if(res.code==200){
				this.goodsAll = res.data
				
				var content = res.data.goods.detail
				let ret = '';
				ret = content.replace(/<img/gi, "<img class='richImg'");
				ret = ret.replace(/<div/gi, "<div class='richDiv'");
				res.data.goods.detail = ret
				
				this.goods = res.data.goods
				
				if(res.data.goods.video){
					this.bannerList = [
						{
							id:-1,
							url:res.data.goods.video
						}
					]
				}else{
					this.bannerList = []
				}
				this.goods.gallery.forEach((item,index)=>{
					this.bannerList.push({
						id:index,
						url:item
					})
				})
				
				// 规格
				this.selGoods = {...res.data.goodsProductList[0]}
				this.selGoodsArr = [...res.data.goodsProductList[0].specifications]
				this.goodsProductList = res.data.goodsProductList
				this.goodsSpecificationVoList = res.data.goodsSpecificationVoList
			}else{this.Tips(res.msg,'error')}
		},
		// 选择规格
		selGuige(index,itm){
			this.$set(this.selGoodsArr,index,itm.value)
			var guigeStr = this.selGoodsArr.join(',')
			var goodsProductList = [...this.goodsProductList]
			for(var i in goodsProductList){
				if(goodsProductList[i].specifications.join(',') == guigeStr){
					this.selGoods = {...goodsProductList[i]}
				}
			}
		},
		// 轮播
		playVideo() {
			const videoEl = this.$el.querySelector('.carousel-video')
			if (videoEl) {
				videoEl.play()
				const overlay = this.$el.querySelector('.video-poster-overlay')
				if (overlay) overlay.style.display = 'none'
			}
		},
		onCarouselChange(index) {
			this.currentSlide = index
			this.scrollThumbIntoView(index)
		},
		goToSlide(index) {
			this.currentSlide = index
			this.$refs.carouselRef && this.$refs.carouselRef.setActiveItem(index)
			this.scrollThumbIntoView(index)
		},
		scrollThumbIntoView(index) {
			// this.$nextTick(() => {
			// 	const strip = this.$refs.thumbStrip
			// 	if (!strip) return
			// 	const items = strip.querySelectorAll('.thumb-item')
			// 	if (items[index]) {
			// 		items[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
			// 	}
			// })
		},
		// 数量
		increaseQty() {
			let newNum = this.quantity + 1;
			if (newNum < 1) newNum = 1;
			if (newNum > this.selGoods.number) newNum = this.selGoods.number;
			this.quantity = newNum
		},
		decreaseQty() {
			if (this.quantity > 1) {
				this.quantity = this.quantity - 1
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.shop-msg-page {
	width: 100%;
	min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 60px;
}
.richImg {
	width: 100%!important;
	height: auto;
	display: block;
	max-width: auto!important;
}
.richDiv {
	width: 100%!important;
	height: auto;
	display: block;
	max-width: auto!important;
}
/* ===================================================================
   产品详情卡片
   =================================================================== */
.product-detail-card {
	width: 1128px;
	margin: 32px auto 0;
	background: #fff;
	border-radius: 8px;
	padding: 23px 24px 28px 23px;
	display: flex;
	box-sizing: border-box;
}
.product-left-col {
	width: 406px;
	flex-shrink: 0;
}
.carousel-main-wrap {
	width: 394px;
	height: 394px;
	border-radius: 12px;
	overflow: hidden;
	position: relative;
}
.carousel-main-wrap ::v-deep .el-carousel__container {
	border-radius: 12px;
	overflow: hidden;
}
.carousel-main-wrap ::v-deep .el-carousel__arrow {
	width: 32px;
	height: 32px;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.9);
	color: #333;
	font-size: 16px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
	transition: background 0.25s;
}
.carousel-main-wrap ::v-deep .el-carousel__arrow:hover {
	background: #fff;
}
.carousel-main-wrap ::v-deep .el-carousel__arrow i {
	font-size: 18px;
}
.carousel-image {
	width: 100%;
	height: 394px;
	display: block;
	cursor: zoom-in;
}

/* 视频项 */
.carousel-video-wrap {
	width: 100%;
	height: 394px;
	position: relative;
	background: #f0f0f0;
	overflow: hidden;
}
.carousel-video {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}
.video-poster-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.25);
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 2;
	transition: background 0.3s;
}
.video-poster-overlay:hover {
	background: rgba(0, 0, 0, 0.35);
}
.play-big-icon {
	width: 60px;
	height: 60px;
	opacity: 0.9;
	transition: transform 0.3s, opacity 0.3s;
}
.video-poster-overlay:hover .play-big-icon {
	transform: scale(1.1);
	opacity: 1;
}

/* 缩略图区域 */
.thumbnail-strip-wrap {
	margin-top: 12px;
	overflow: hidden;
}
.thumbnail-strip {
	display: flex;
	overflow-x: auto;
	overflow-y: hidden;
	padding-bottom: 6px;
	scroll-behavior: smooth;
	-webkit-overflow-scrolling: touch;
}
.thumbnail-strip::-webkit-scrollbar {
	height: 4px;
}
.thumbnail-strip::-webkit-scrollbar-thumb {
	background: #ccc;
	border-radius: 2px;
}
.thumbnail-strip::-webkit-scrollbar-track {
	background: transparent;
}
.thumb-item {
	flex-shrink: 0;
	width: 56px;
	height: 56px;
	border-radius: 6px;
	margin-right: 8px;
	border: 2px solid transparent;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	transition: border-color 0.25s, opacity 0.25s;
	opacity: 0.6;
	box-sizing: border-box;
}
.thumb-item:last-child {
	margin-right: 0;
}
.thumb-item.thumb-active {
	border-color: #0096FF;
	opacity: 1;
}
.thumb-item:hover {
	opacity: 0.9;
	border-color: #0096FF;
}
.thumb-img {
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 4px;
}
.thumb-video-mark {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 1;
	width: 20px;
	height: 20px;
}
.thumb-video-mark .el-image {
	width: 20px;
	height: 20px;
}

/* 右侧信息 */
.product-right-col {
	flex: 1;
	margin-left: 24px;
}
.product-title {
	font-size: 18px;
	font-weight: 500;
	color: #333;
	margin: 0;
	line-height: 1.4;
	flex:1;
	padding-right: 10px;
}
.product-title-w{
	align-items: flex-start;
}
.price-row {
	display: flex;
	align-items: baseline;
	margin-top: 20px;
}
.price-value {
	color: #FC3C3C;
	display: inline-flex;
	align-items: baseline;
}
.price-symbol {
	font-size: 14px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.price-amount {
	font-size: 24px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}
.price-sales {
	font-size: 12px;
	color: #999;
	margin-left: 12px;
}
.store-row-w{
	
}
.store-row {
	display: flex;
	align-items: center;
	margin-top: 24px;
}
.store-avatar {
	width: 40px;
	height: 40px;
	flex-shrink: 0;
}
.store-info {
	margin-left: 8px;
	display: flex;
	flex-direction: column;
}
.store-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
}
.store-stars {
	display: flex;
	align-items: center;
	margin-top: 4px;
}
.store-stars .el-image {
	width: 12px;
	height: 12px;
	margin-right: 2px;
}
.store-stars .el-image:last-child {
	margin-right: 0;
}
.store-arrow {
	width: 16px;
	height: 16px;
	margin-left: 8px;
	cursor: pointer;
}

.coupon-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 16px;
}
.coupon-btn {
	width: 106px;
	height: 32px;
	background: #FFF1EB;
	border-radius: 6px;
	font-size: 14px;
	font-weight: 500;
	color: #FF5000;
	text-align: center;
	line-height: 32px;
	cursor: pointer;
}
.action-btns {
	display: flex;
	align-items: center;
}
.action-btn {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 49px;
	cursor: pointer;
}
.action-btn .el-image {
	width: 18px;
	height: 18px;
}
.action-btn span {
	font-size: 13px;
	color: #B7B9C5;
	margin-top: 4px;
}
.action-divider {
	width: 1px;
	height: 32px;
	background: #EDEDED;
	margin: 0 16px;
}

.specs-row {
	display: flex;
	align-items: flex-start;
	flex-wrap: wrap;
	&:first-child{
		margin-top: 12px;
	}
}
.specs-label {
	font-size: 14px;
	color: #333;
	font-weight: 400;
	flex-shrink: 0;
	margin-right: 24px;
	line-height: 42px;
	width: 100%;
	margin-bottom: 0px;
}
.spec-options {
	display: flex;
	flex-wrap: wrap;
}
.spec-option {
	padding: 0 12px;
	// width: 68px;
	height: 42px;
	border: 1px solid #DEE2E7;
	border-radius: 4px;
	text-align: center;
	line-height: 42px;
	font-size: 14px;
	color: #333;
	cursor: pointer;
	margin-right: 16px;
	margin-bottom: 12px;
	box-sizing: border-box;
}
.spec-option:last-child {
	margin-right: 0;
}
.spec-option.spec-active {
	border-color: #0096FF;
	color: #0096FF;
}

.quantity-row {
	display: flex;
	align-items: center;
	margin-top: 8px;
	flex-wrap: wrap;
}
.quantity-label {
	font-size: 14px;
	color: #333;
	font-weight: 400;
	flex-shrink: 0;
	margin-right: 24px;
	width: 100%;
	margin-bottom: 12px;
}
.quantity-control {
	width: 112px;
	height: 32px;
	border: 1px solid #DADDE0;
	border-radius: 4px;
	display: flex;
	align-items: center;
	overflow: hidden;
}
.qty-btn {
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	flex-shrink: 0;
}
.qty-btn .el-image {
	width: 16px;
	height: 16px;
}
.qty-input {
	width: 48px;
	height: 32px;
	flex-shrink: 0;
}
.qty-input ::v-deep .el-input__inner {
	height: 32px;
	border: none;
	border-radius: 0;
	text-align: center;
	font-size: 14px;
	color: #333;
	padding: 0;
	border-left: 1px solid #DADDE0;
	border-right: 1px solid #DADDE0;
	box-shadow: none;
}

.purchase-notes {
	margin-top: 20px;
}
.note-line {
	margin: 0;
	line-height: 1.6;
}
.note-star {
	color: #FC3C3C;
	font-size: 13px;
}
.note-text {
	color: #666;
	font-size: 13px;
}

.cart-btns {
	display: flex;
	margin-top: 30px;
}
.cart-btn {
	width: 106px;
	height: 42px;
	border-radius: 6px;
	text-align: center;
	line-height: 42px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	margin-right: 16px;
}
.cart-btn:last-child {
	margin-right: 0;
}
.cart-add {
	background: #F0F7FD;
	color: #0096FF;
}
.cart-buy {
	background: #0096FF;
	color: #fff;
}

/* ===================================================================
   底部区域：推荐商品 + 商品详情
   =================================================================== */
.product-bottom-section {
	width: 1128px;
	margin: 24px auto 0;
	display: flex;
}

/* 左侧推荐 */
.recommend-sidebar {
	width: 270px;
	background: #fff;
	border-radius: 8px;
	padding: 20px 24px 24px;
	flex-shrink: 0;
	margin-right: 24px;
	box-sizing: border-box;
}
.recommend-title {
	font-size: 18px;
	font-weight: 500;
	color: #333;
	margin: 0 0 16px 0;
}
.recommend-divider {
	height: 1px;
	background: rgba(233, 233, 233, 0.5);
	margin: 16px 0;
}
.recommend-item {
	margin-bottom: 0px;
}
.recommend-img {
	width: 222px;
	height: 222px;
	border-radius: 10px;
	display: block;
	cursor: pointer;
}
.name{
	margin-top: 8px;
	font-size: 14px;
}
.recommend-tag {
	padding: 0 2px;
	height: 18px;
	border-radius: 2px;
	font-size: 12px;
	line-height: 18px;
	display: inline-block;
	margin-right: 4px;
}
.tag-orange {
	background: #FF7120;
	color: #fff;
}
.tag-blue {
	background: #E9F5FF;
	color: #0096FF;
	border: 1px solid #0096FF;
}
.recommend-name1 {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	margin-top: 4px;
	padding-left: 0;
	display: inherit;
}
.recommend-name2 {
	font-size: 14px;
	font-weight: 500;
	color: #333;
}
.recommend-price {
	color: #FC3C3C;
	margin-top: 10px;
	display: inline-flex;
	align-items: baseline;
}
.r-price-symbol {
	font-size: 12px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.r-price-value {
	font-size: 18px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}

/* 右侧详情 */
.detail-main {
	flex: 1;
	background: #fff;
	border-radius: 8px;
	padding: 24px 32px 32px;
	box-sizing: border-box;
}
.detail-title {
	font-size: 18px;
	font-weight: 500;
	color: #333;
	margin: 0 0 24px 0;
	text-align: center;
}
.detail-image-wrap {
	width: 100%;
}
.detail-image {
	width: 100%;
	height: auto;
	display: block;
	cursor: pointer;
}
</style>
